import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

import * as router from '@era/stores';
import * as fromAlarm from '../../sub-features/room/alarm/alarm-store/alarm.reducer';
import * as fromRoom from './rooms.reducer';

export interface RoomState {
  rooms: fromRoom.RoomState;
  alarm: fromAlarm.AlarmState;
}

export const reducers: ActionReducerMap<RoomState> = {
  rooms: fromRoom.roomsReducer,
  alarm: fromAlarm.alarmReducer,
};

export const selectRoomState = createFeatureSelector<fromRoom.RoomState>(fromRoom.inRoomRoomsFeatureKey);

export const selectRoomIds = createSelector(selectRoomState, fromRoom.selectRoomIds);

export const selectRoomEntities = createSelector(selectRoomState, fromRoom.selectRoomEntities);

export const selectAllRooms = createSelector(selectRoomState, fromRoom.selectAllRooms);

export const selectRoomTotal = createSelector(selectRoomState, fromRoom.selectRoomTotal);

export const selectCurrentRoomId = createSelector(
  router.RouterStoreSelectors.selectRouterParam('location'),
  router.RouterStoreSelectors.selectRouterParam('room'),
  (locationId: string, roomId: string) => `${locationId}-${roomId}`
);

export const selectCurrentRoom = createSelector(
  selectRoomEntities,
  selectCurrentRoomId,
  (roomEntities, roomId) => roomEntities[roomId]
);

export const selectCurrentRoomCheckinState = createSelector(selectCurrentRoom, (room) => room?.CheckedIn);

export const selectHasSelectedRoom = createSelector(selectCurrentRoom, (room) => !!room);
